import { render, staticRenderFns } from "./BalanceEmptyBlock.vue?vue&type=template&id=465e9c6a&scoped=true&"
import script from "./BalanceEmptyBlock.vue?vue&type=script&lang=js&"
export * from "./BalanceEmptyBlock.vue?vue&type=script&lang=js&"
import style0 from "./BalanceEmptyBlock.vue?vue&type=style&index=0&id=465e9c6a&scoped=true&class=scss&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "465e9c6a",
  null
  
)

export default component.exports